import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-info-labels-display',
  templateUrl: './info-labels-display.component.html',
  styleUrls: ['./info-labels-display.component.scss']
})
export class InfoLabelsDisplayComponent implements OnInit {
  @Input() data;
  constructor() { }

  ngOnInit() {
  }

}
